<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">

        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->
        <config-hang @click.native="addChangeHostBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/zhuji_hei.png"
               alt="">
          <span slot="config_hang_ele2">主机管理</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="">
        </config-hang>
        <!-- //代号20220220-6 -->
        <config-hang @click.native="deviceGoOnlineBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/shezhi_hei.png"
               alt="">
          <span slot="config_hang_ele2">设备添加与维护</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="">
        </config-hang>
        <!-- //代号20220220-6 -->
        <config-hang @click.native="deviceListBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/shebei_liebiao.png"
               alt="">
          <span slot="config_hang_ele2">已有设备属性管理</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="">
        </config-hang>
        <!-- <config-hang>
          <img slot="config_hang_ele1" src="~assets/img/config/peiwang_hei.png" alt="">
          <span slot="config_hang_ele2" >一键配网</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt="">
        </config-hang> -->

      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from 'components/common/config/config-hang'
export default {
  data () {
    return {};
  },
  components: {
    topNav,
    topNavItem,
    configHang
  },
  methods: {
    addChangeHostBtnHandle () {
      ///主机管理被点击了
      this.$router.push("hostManage")
    },
    deviceGoOnlineBtnHandle () {
      ///设备上线设置被点击了 
      this.$router.push("selectDeviceHost")
    },
    deviceListBtnHandle () {
      ///设备列表按钮被点击了
      this.$router.push("deviceTypeList")
    }
  },

  mounted () {
    console.log("mounted阶段");
  },
  created () {
    // console.log("created阶段");
    // /// 请求区域信息接口，获取数据
    // this.$request({
    //   method: "post",
    //   url: "/region/findRegion",
    //   data: {
    //     token: this.$store.state.token
    //   }
    // })
    //   .then(res => {
    //     if (res.data.code != 0) {
    //       this.$showTipsToast(3, res.data.message);
    //       ////说明信息填写错误,控制失败了，
    //       return;
    //     } else {
    //       ////、控制成功了
    //       this.serveRegionListData = res.data.data; ////拿到服务器返回的数据结果
    //       // this.$showTipsToast(1, "获取成功", true); ////提示框
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }
};
</script>

<style>
</style>